import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '../button/IconButton';

export default class SwitchBase extends Component {
  static propTypes = {
    inputType: PropTypes.string,
    prefixCls: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    disabled: PropTypes.bool,
    checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    defaultChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    checkedIcon: PropTypes.node,
    className: PropTypes.string,
    uncheckedIcon: PropTypes.node,
    indeterminate: PropTypes.bool,
    indeterminateIcon: PropTypes.node,
    iconRender: PropTypes.func,
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
  };

  static defaultProps = {
    type: 'checkbox',
    defaultChecked: false,
    prefixCls: 'ne-switch-base',
    disabled: false,
    size: 'medium',
  };

  static getDerivedStateFromProps(props, state) {
    const { defaultChecked } = props;
    if (!state.isControlled && defaultChecked !== state.prevDefaultChecked) {
      return {
        checked: defaultChecked,
        prevDefaultChecked: defaultChecked,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    const { defaultChecked, checked } = props;

    this.isControlled = checked !== undefined;
    this.state = {
      checked: defaultChecked,
      isControlled: this.isControlled,
      prevDefaultChecked: defaultChecked,
    };
  }

  componentDidUpdate() {
    const { checked } = this.props;
    if (!this.isControlled && checked !== undefined) {
      this.isControlled = true;
      this.setState({
        checked: null,
      });
    }
  }

  onInputChange = e => {
    const { checked } = e.target;
    const { onChange } = this.props;
    if (!this.isControlled) {
      this.setState({ checked });
    }
    if (onChange) {
      onChange(e, checked);
    }
  };

  getEl = el => {
    const { inputRef } = this.props;
    if (inputRef) {
      inputRef(el);
    }
  };

  render() {
    const {
      prefixCls,
      inputType,
      inputClass,
      checkedIcon,
      uncheckedIcon,
      indeterminate,
      indeterminateIcon,
      inputRef,
      className,
      disabled,
      checked: propsChecked,
      defaultChecked,
      label,
      onChange,
      iconRender,
      error,
      size,
      inputProps,
      status,
      errorIcon,
      loadingIcon,
      successIcon,
      tabIndex,
      showStatusIcon,
      ...other
    } = this.props;
    const { checked: stateChecked } = this.state;
    const checked = this.isControlled ? propsChecked : stateChecked;
    const icon = indeterminate ? indeterminateIcon : checkedIcon;
    return (
      <label
        className={classNames(
          `${prefixCls}`,
          {
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-checked`]: checked,
            [`${prefixCls}-${size}`]: size,
          },
          className,
        )}>
        <IconButton
          component="span"
          className={`${prefixCls}-button`}
          variant="text"
          active={checked}
          tabIndex={null}
          disabled={disabled}
          size="small">
          <input
            className={`${prefixCls}-input`}
            checked={checked}
            onChange={this.onInputChange}
            ref={this.getEl}
            tabIndex={tabIndex}
            disabled={disabled}
            {...inputProps}
            {...other}/>
          {iconRender
            ? iconRender(indeterminate ? 'indeterminate' : checked ? 'checked' : 'unchecked')
            : checked
            ? icon
            : uncheckedIcon}
        </IconButton>
        <span className={`${prefixCls}-label-text`}>
          {typeof label === 'function' ? label(checked, disabled) : label}
        </span>
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./src/switchBase/SwitchBase.jsx